import React, { useEffect, useState } from "react";
import { IPetsDashboardResponseModel } from "../../../../typings/models/PetsDashboardResponseModel";
import { useNavigate, Link } from "react-router-dom";
import { IOwnerStatus } from "../../../../typings/models/OwnerStatus";
import { ownerChangeToNewOwner } from "../../../../api/apimethods";
import { format } from "date-fns";
import moment from "moment";

interface RegGridRowProps {
  data: any;
  onRemoveItem: (item: any) => void;
}

const PetsRegGridRow: React.FC<RegGridRowProps & { activeButton: string }> = ({
  data,
  onRemoveItem,
  activeButton,
}) => {
  let navigate = useNavigate();

  const handlePetsEditClick = () => {
    navigate("/application-for-pets", {
      state: {
        petsRegistrationId: data.petsRegistrationId,
        petsTransferApplicationId: data.petsTransferApplicationId,
        buttonId: "v-pills-petsregedit-tab",
        tabId: "v-pills-petsregedit",
        bannerId: 7,
      },
    });
  };

  return (
    <tr>
      <td className="center-content">
        <a href="#" onClick={handlePetsEditClick} className="link-style">
          {data.referenceNo}
        </a>
      </td>
      <td>{data.applicationType}</td>
      <td>{data.animalType}</td>
      <td>{data.breed && data.breed.replace(/ *\[[^\]]*]/, "")}</td>
      <td>{data.petsMicrochipNo}</td>
      <td>{data.petsName}</td>
      <td>{data.petsOrigin}</td>
      <td>{data.ownerName}</td>
      {
        <>
          {data.status === "1" && <td>{"Draft"}</td>}
          {data.status === "2" && <td>{"Registered"}</td>}
          {data.status === "3" && <td>{"Registered"}</td>}
          {data.status === "4" && <td>{"Accepted"}</td>}
          {data.status === "5" && <td>{"Declined"}</td>}
          {data.status === "6" && <td>{"Cancelled"}</td>}
        </>
      }
      <td>{moment(data.submittedDate).format("DD/MM/yyyy, hh:mm a")}</td>
      {/* {
                data.status === "3" && (
                    <td>
                        <button
                            type="button"
                            className={`btn btn-outline-success btn-sm`}
                            onClick={handleButtonClick}
                        >
                            Owner Transfer
                        </button>
                    </td>
                )
            } */}
    </tr>
  );
};

export default PetsRegGridRow;
